import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Container, Divider, FormControl, FormLabel, Grid, InputLabel, MenuItem, Paper, Select, TextField, Theme, Typography, createStyles, makeStyles, colors, FormHelperText, TableContainer, TableHead, Table, TableCell, TableRow, TableBody, CircularProgress } from '@material-ui/core';
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { OctaveBand } from '../app/utils/models';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createOctaveBandModel, updateOctaveBandModel, removeOctaveBandModel, getOctaveBandsModels, octaveBandModelList, newProjectResponse } from "../app/reducer/octaveBandModal.reducer";
import { useAppSelector } from "../app/hooks";
import AlertComponent from "../components/general/Alert";
import Chart from "react-google-charts";
import { FanUploadProps } from './Fans'
import DeleteDialog from './DeleteDialog';
import Paths from '../utils/Paths';
import AlertDialog from './AlertDialog';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radioGroup: {
      display: 'flex',
      flexDirection: 'row'
    },
    formControl: {
      width: '100%',
    },
    radioWrapped: {
      marginLeft: theme.spacing(2),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    redOutline: {
      borderColor: "red !important"
    },
    uppercaseText: {
      textTransform: 'uppercase'
    }
  }),
);

enum InputFieldsName {
  SelectOctaveBandId,
  SQ31,
  SQ63,
  SQ125,
  SQ250,
  SQ500,
  SQ1K,
  SQ2K,
  SQ4K,
  SQ8K,
  SQ16K,
}

enum ButtonName {
  Edit,
  Duplicate,
  Delete,
  Submit,
  Back,
  PartialBack,
  PartialUpdate
}
enum UserAction {
  View,
  Edit,
  Delete,
  Duplicate
}

const ButtonVisibleConfig = {
  [UserAction.View]: [ButtonName.Edit,ButtonName.Delete,ButtonName.Duplicate,ButtonName.Back,ButtonName.PartialUpdate],
  [UserAction.Edit]: [ButtonName.Submit,ButtonName.PartialBack],
  [UserAction.Duplicate]: [ButtonName.PartialBack,ButtonName.Submit],
  [UserAction.Delete]: [ButtonName.Edit,ButtonName.Delete,ButtonName.Duplicate,ButtonName.Back],
}

const InputFieldsList = [InputFieldsName.SQ31,
  InputFieldsName.SQ63,
  InputFieldsName.SQ125,
  InputFieldsName.SQ250,
  InputFieldsName.SQ500,
  InputFieldsName.SQ1K,
  InputFieldsName.SQ2K,
  InputFieldsName.SQ4K,
  InputFieldsName.SQ8K,
  InputFieldsName.SQ16K]

const InputFieldsEnableConfig:any = {
  [UserAction.View]: InputFieldsList,
  [UserAction.Edit]: [InputFieldsName.SelectOctaveBandId],
  [UserAction.Duplicate]: [],
  [UserAction.Delete]: [],
}

export default function OctaveBands({ setIndex, octaveBandID, setVisibleModule,isFromFanList,footerDisable }: FanUploadProps) {

  const { register, handleSubmit, setValue, getValues, control, formState: { errors }, setError, reset } = useForm<OctaveBand>();
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [value, setSelectedValue] = useState<string | null>(null);
  const [inputValue, setInputValue] = useState('');
  const [bladeModels, setBladeModels] = useState<any[] | undefined>([]);
  const [options, setOptions] = useState<string[]>([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [buttonAction, setButtonAction] = useState<string>('Edit');
  const [openAlert, setOpenAlert] = React.useState<boolean>(false);
  const [openAlertMesage, setOpenAlertMessage] = React.useState<string>("");
  const [dbValues, setDbValues] = useState<string[]>([]);
  const [octaveBandIDList,setOctaveBandIdList] = useState<string[]>([]);
  const [duplicateBandId,setDuplicateBandId] = useState("");
  const [warningDialog,setWarningDialog] = useState(false);
  const [warningDialogText,setWarningDialogText] = useState("");
  const [loading,setLoading] = useState(false);


  const modelList = useAppSelector(octaveBandModelList);
  const newProjectResponses = useAppSelector(newProjectResponse);
  const rows = [
    { id: 1, name: '31.5' },
    { id: 2, name: '63' },
    { id: 3, name: '125' },
    { id: 4, name: '250' },
    { id: 5, name: '500' },
    { id: 6, name: '1K' },
    { id: 7, name: '2K' },
    { id: 8, name: '4K' },
    { id: 9, name: '8K' },
    { id: 10, name: '16K' },
  ];

  const chartDataFormate = [
    ['Octave', 'db(A)'],
    ['31.5', 0],
    ['63', 0],
    ['125', 0],
    ['250', 0],
    ['500', 0],
    ['1000', 0],
    ['2000', 0],
    ['4000', 0],
    ['8000', 0],
    ['16000', 0],
  ]
  const [chartData, setChartData] = useState(chartDataFormate);

  const [userAction,setUserAction] = useState(UserAction.View);

  const cache: any = {};
  const memoizedGetBladeModels = async () => {
    if (cache.bladeModels) {
      return cache.bladeModels;
    }
    const bladeModels = await dispatch(getOctaveBandsModels());
    cache.bladeModels = bladeModels;

    return bladeModels;
  };
  const miniRefresh = async () => { 
    await fetchUpdatedData();
    if (octaveBandID) {
      setSelectedValue(octaveBandID);
      const { newValues, selectedItem } = updateNewValues(octaveBandID);
      Object.keys(newValues).forEach((fieldName: any) => {
        setValue(fieldName, selectedItem[fieldName]);
      });
    }
  }

  function disableParentFooter() {
    if(isFromFanList)
      footerDisable(true)
  }

  function enableParentFooter() {
    if(isFromFanList)
      footerDisable(false)
  }

  const fetchUpdatedData = async () => {
    setLoading(true);
    const bladeModels = await memoizedGetBladeModels();
    const modelList = bladeModels.payload.data
    setBladeModels(modelList)
    const options = modelList ? modelList.map((item: any) => item?.octaveBandID) : [];
    setOctaveBandIdList([...options].sort());
    setOptions(options.sort())
    setLoading(false);
  }

  useEffect(() => {
    (async () => {
      setLoading(true);
      if (setIndex) {
        setIndex(3);
      }
      await fetchUpdatedData(); // Wait for fetchUpdatedData to complete
      if (octaveBandID) {
        setSelectedValue(octaveBandID);
        const { newValues, selectedItem } = updateNewValues(octaveBandID);
        Object.keys(newValues).forEach((fieldName: any) => {
          setValue(fieldName, selectedItem[fieldName]);
        });
      }
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    if(dbValues.length<=0)
      return;
    const tempChartData = [...chartData];
    const updatedChartData = [['Octave', 'db(A)']];
    dbValues.forEach((elements,index) => {
      updatedChartData.push([tempChartData[index+1][0].toString(),elements])
    })
    setChartData(updatedChartData);
  },[dbValues]);


  const updateNewValues = (inputValue: any) => {
    const selectedItem = bladeModels && bladeModels?.find(item => item.octaveBandID == inputValue)
    if (!bladeModels?.length || !selectedItem) {
      return { newValues: {}, selectedItem: {} };
    }

    const newValues: any = {
      octaveBandID: selectedItem.octaveBandID,
      dB: selectedItem.dB,
    };
    setDbValues(selectedItem.dB)
    return { newValues: newValues, selectedItem: selectedItem };
  }

  const createDuplicateData = (inputValue: any,dB: any[],octaveBandID:string) => {
    const selectedItem = bladeModels && bladeModels?.find(item => item.octaveBandID == inputValue)
    if (!bladeModels?.length || !selectedItem) {
      return { };
    }
    const newValues: any = {
      octaveBandID: octaveBandID,
      dB: dB,
      fanDiameter: selectedItem.fanDiameter,
      numOfBlades: selectedItem.numOfBlades,
      rpm: selectedItem.rpm
    };
    return newValues;
  }

  // ++ Track state of dbValues and update chart data accordingly ++
  useEffect(() => {
    if(dbValues.length<=0)
      return;
    const tempChartData = [...chartData];
    const updatedChartData = [['Octave', 'db(A)']];
    dbValues.forEach((elements,index) => {
      updatedChartData.push([tempChartData[index+1][0].toString(),elements])
    })
    setChartData(updatedChartData);
  },[dbValues]);

  const handleTextChange = (index: any, value: any) => {
    const newTextData: any = [...dbValues];
    newTextData[index] = parseFloat(value);
    setDbValues(newTextData);
  };

  const handleAddNewItem = () => {
    if (inputValue.trim() && !options.includes(inputValue)) {
      setOptions([...options, inputValue]);
      setSelectedValue(inputValue);
    }
    if (options.length == 0) {
      fetchUpdatedData();
    }
  };

  const onSubmit: SubmitHandler<OctaveBand> = async data => {
    if(userAction === UserAction.Duplicate && octaveBandIDList.includes(inputValue))
      return;
    let newData = { db:[...dbValues], octaveBandID: inputValue };
    if (newData.octaveBandID != "") {
      if (buttonAction === "Edit") {
        await dispatch(updateOctaveBandModel(newData));
        setOpenAlertMessage('Octave Band Data updated successfully')
        reset();
        setSelectedValue('');
      } else {
        const duplicateData = createDuplicateData(duplicateBandId,newData.db,inputValue)
        await dispatch(createOctaveBandModel(duplicateData));
        if (!newProjectResponses) {
          setOpenAlertMessage('New data created successfully');
          reset();
          setSelectedValue('');
        }
      }
      setOpenAlert(true);
    }
  };

  const onInputChange = (event: any, newInputValue: any,reason: string) => {

    if(reason === "clear" && userAction !== UserAction.Duplicate)  {
      setInputValue(newInputValue);
      setDbValues([]);
      setChartData(chartDataFormate);
      return;
    }
    setInputValue(newInputValue);
    if (!bladeModels && !inputValue) {
      return false;
    }
    if(userAction === UserAction.Duplicate)
      return;
    const { newValues, selectedItem } = updateNewValues(newInputValue)
    console.log({
      newValues:newValues,
      selectedItem:selectedItem
    })
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    })

  }

  const editField = () => {
    if(inputValue === null || inputValue === undefined || inputValue === "") {
      setWarningDialog(true);
      setWarningDialogText("Please select a Octave Band ID for edit.");
      return;
    }
    setUserAction(UserAction.Edit);
    setButtonAction("Edit");
    disableParentFooter();
    console.log("Edit", bladeModels, inputValue)
    if (!bladeModels && !inputValue) {
      return false;
    }
    setDuplicateBandId(inputValue);
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
  }

  const duplicateField = () => {
    if(inputValue === null || inputValue === undefined || inputValue === "") {
      setWarningDialog(true);
      setWarningDialogText("Please select a Octave Band ID to duplicate.");
      return;
    }
    setUserAction(UserAction.Duplicate);
    setButtonAction("Duplicate");
    if (!bladeModels && !inputValue) {
      return false
    }
    setDuplicateBandId(inputValue);
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
  }


  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if(inputValue === null || inputValue === undefined || inputValue === "") {
      setWarningDialog(true);
      setWarningDialogText("Please select a Octave Band Id for deletion.");
      return;
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    handleClose();
    setOpenAlertMessage('Data Deleted successfully');
    setOpenAlert(true);
  };


  // ! @Deprecated
  const onDelete = async () => {
    setButtonAction("Delete");
    if (!bladeModels && !inputValue) {
      return false
    }
    const { newValues, selectedItem } = updateNewValues(inputValue)
    Object.keys(newValues).forEach((fieldName: any) => {
      setValue(fieldName, selectedItem[fieldName]);
    });
    await dispatch(removeOctaveBandModel(newValues));
    setOpenAlertMessage('Deleted HUB successfully');
    setOpenAlert(true);
  }

  const refresh = async () => {
    if(octaveBandID) {
      await miniRefresh();
      setUserAction(UserAction.View);
      enableParentFooter();
      return;
    }
    fetchUpdatedData();
    history.go(0);
  }

  const isTextFieldEnable = (name:InputFieldsName):boolean => {
    return InputFieldsEnableConfig[userAction].includes(name);
  }

  const isButtonVisible = (name:ButtonName):boolean => {
    return ButtonVisibleConfig[userAction].includes(name);
  }

  const isPartialButtonVissible = ():any => {
    return isFromFanList && isButtonVisible(ButtonName.PartialUpdate);
  }

  const onPartialUpdate = () => {
    if(setVisibleModule && inputValue) {
      setVisibleModule(inputValue);
      setWarningDialog(true);
      setWarningDialogText("New Octave Band Updated.")
    }
  }


  return (
    <div className="page-wrapper">
      <Container maxWidth="xl">
        <Paper className="form-wrapper">
          <Typography variant="h5" gutterBottom>
            <b className={classes.uppercaseText}>{buttonAction} Octave Band Details</b>
          </Typography>
          <hr />
          <Divider />
          <AlertDialog open={warningDialog} message={warningDialogText} handleClose={() => setWarningDialog(false)} />
          <DeleteDialog open={open} handleClose={handleClose} path={Paths.OctaveBand} idType="octaveBandID" id={inputValue} handleDelete={handleDelete}/>
          <AlertDialog  open={openAlert} message={openAlertMesage} handleClose={() => { setOpenAlert(false);refresh(); }} />
          {/* <AlertComponent open={openAlert} message={openAlertMesage} severity="success" handleClose={() => { setOpenAlert(false) }} /> */}

          <form id="fan-details-form" style={{ padding: '5px' }} onSubmit={handleSubmit(onSubmit)}>
            {(!inputValue || octaveBandIDList.includes(inputValue)) && (buttonAction == 'Duplicate') && (
              <p className="MuiFormHelperText-root MuiFormHelperText-contained" style={{ color: 'red' }}>Add new Octave Band</p>
            )}
            {inputValue && buttonAction == 'Duplicate' && newProjectResponses?.error?.errors[0].bladeModel && (
              <p className="MuiFormHelperText-root MuiFormHelperText-contained" style={{ color: 'red' }}>{newProjectResponses?.error?.errors[0].bladeModel}</p>
            )}

            <Grid container spacing={6}>
              <Grid item xs={12} lg={4}>
                <Autocomplete
                  style={{ width: '260px' }}
                  value={value}
                  inputValue={inputValue}
                  onInputChange={onInputChange}
                  options={options}
                  disabled={isTextFieldEnable(InputFieldsName.SelectOctaveBandId)}
                  freeSolo
                  renderInput={(params: any) => (
                    <TextField
                      
                      {...params}
                      label="Select or add new OctaveBand ID"
                      variant="outlined"
                    />
                  )}

                  onBlur={handleAddNewItem}
                  onKeyDown={(event: any) => {
                    if (event.key === 'Enter') {
                      handleAddNewItem();
                    }
                  }}
                />

              </Grid>
              { isButtonVisible(ButtonName.Edit) &&
                <Grid item xs={12} lg={3}>
                  <Button variant="contained" onClick={editField} style={{ color:'white', width: '180px',backgroundColor:'#41bb98' }}>EDIT</Button>
                </Grid>
              }
              {
                (octaveBandID && isButtonVisible(ButtonName.Submit)) && (
                <Grid item xs={12} lg={3}>
                  <Button style={{backgroundColor:'#41bb98'}} variant="contained" color="primary" type='submit'>{buttonAction} Submit</Button>
                </Grid>
                )
              }
               {isPartialButtonVissible() && (
                <Grid item xs={12} lg={2}>
                <Button variant="contained" style={{color:'white'}} color="secondary" type='button' onClick={onPartialUpdate}>Update</Button>
                </Grid>)
              }
              { isButtonVisible(ButtonName.PartialBack) &&
                <Grid item xs={12} lg={3}>
                  <Button variant="contained" style={{ color:'white', backgroundColor:'#6b6666',width: '180px' }}  onClick={() => { 
                    setButtonAction("Edit");
                    setUserAction(UserAction.View)
                    if(userAction === UserAction.Duplicate) {
                      setInputValue(duplicateBandId);
                      onInputChange(null,duplicateBandId,"REFRESH")
                    }
                    if(userAction === UserAction.Edit) {
                      onInputChange(null,duplicateBandId,"REFRESH")
                    }
                    enableParentFooter();
                  }}>Back</Button>
                </Grid>
              }
              {!octaveBandID &&
                <>
                  { isButtonVisible(ButtonName.Duplicate) &&
                    <Grid item xs={12} lg={2}>
                      <Button variant="contained" color="secondary" style={{color:'white', backgroundColor: 'rgb(245 154 36)' }} onClick={duplicateField}>DUPLICATE</Button>
                    </Grid>
                  }
                  { isButtonVisible(ButtonName.Delete) &&
                    <Grid item xs={12} lg={3}>
                      <Button variant="contained" color="secondary" style={{ color:'white', backgroundColor: 'rgba(217, 0, 27, 1)', width: '180px' }} onClick={handleOpen}>DELETE</Button>
                    </Grid>
                  }
                </>
              }

            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>

                      <TableRow style={{ background: '#dedede' }}>
                        <TableCell>OCTAVE (Hz)</TableCell>
                        {rows.map((row) => (
                          <>
                            <TableCell component="th" scope="row">
                              {row.name}
                            </TableCell>
                          </>
                        ))}
                      </TableRow>

                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell style={{ background: '#dedede' }}>
                          SPL db (A)
                        </TableCell>
                        {dbValues.map((row, index) => {
                          return (
                          <>
                            <TableCell>
                              <TextField
                                id={"SQL_TEXT_BOX".concat(index.toString())}
                                disabled={isTextFieldEnable(InputFieldsList[index])}
                                type="number"
                                value={row}
                                // {...register(`dB.${index}`, { required: true })}
                                onChange={(e) => handleTextChange(index, e.target.value)}
                              />
                            </TableCell>
                          </>
                        )})}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <Typography variant="h5" gutterBottom>
                  <b>Octave Band Graph</b>
                </Typography><br />
                <Chart
                  width={'100%'}
                  height={'400px'}
                  chartType="Bar"
                  loader={<div>Loading Chart</div>}
                  data={
                    chartData
                  }
                  options={{
                    hAxis: {
                      title: 'Hz',
                    },
                    vAxis: {
                      title: 'db(A)',
                    },
                    series: {
                      1: { curveType: 'function' }
                    },
                  }}
                />
              </Grid>
            </Grid>
            {!octaveBandID &&
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                { isButtonVisible(ButtonName.Submit) &&
                  <Grid item xs={12} lg={12}>
                    <Button style={{backgroundColor:'#41bb98'}} variant="contained" color="primary" type='submit'>{buttonAction} Submit</Button>  {/*this is EDIT SUBMIT button on octave band's edit page */} 
                  </Grid>
                }
                { isButtonVisible(ButtonName.Back) &&
                  <Grid item xs={12} lg={12}>
                    <Button style={{backgroundColor:'#6b6666'}} variant="contained" color="primary" type='button' onClick={() => history.goBack()}>Back</Button>
                  </Grid>
                }
              </Grid>
            }
          </form>
        </Paper>
        
        <Dialog open={loading} aria-labelledby="delete-dialog-title">
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>
      </Container>
    </div>
  );

}

